
import { GraphQLError } from 'graphql';
import EDTypography from '../../BaseComponents/Typography/EDTypography';

interface IProps {
  error: GraphQLError;
}
const ServerErrorView: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { error } = props;
  return (
    <>
      {/* Render all extensions */}
      {Object.keys(error.extensions || {}).map(extension => {
        if (
          error.extensions &&
          Object.prototype.hasOwnProperty.call(!error.extensions, extension)
        ) {
          return null;
        }

        if (!error || !error.extensions) {
          return null;
        }

        return (
          <>
            <EDTypography>
              {extension}: {error.extensions[extension]}
            </EDTypography>
          </>
        );
      })}
      {/* Render path */}
      {error.path && error.path.length > 0 && (
        <>
          <EDTypography>Path: {error.path.join('.')}</EDTypography>
        </>
      )}
      {/* Render locations */}
      {error.locations && error.locations.length > 0 && (
        <>
          <EDTypography>Locations:</EDTypography>
          {error.locations.map((location, index) => (
            <EDTypography key={index}>
              Line {location.line}, Column {location.column}
            </EDTypography>
          ))}
        </>
      )}
    </>
  );
};

export default ServerErrorView;
